import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";

interface DocRef {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  product: { slug: string; display_name: string };
}

export default function DocsListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["portal-docs"],
    queryFn: () => api<{ items: DocRef[] }>("/portal/docs"),
  });

  const items = data?.items ?? [];
  return (
    <div className="space-y-4">
      <div className="text-xs text-slate-500">
        <Link to="/my-tickets" className="underline">← My tickets</Link>
      </div>
      <h1 className="text-2xl font-semibold">Help docs</h1>
      {isLoading ? (
        <div className="text-slate-600">Loading…</div>
      ) : items.length === 0 ? (
        <div className="rounded-md border border-slate-200 bg-white p-6 text-center text-sm text-slate-600">
          No public docs yet.
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((d) => (
            <li key={d.id}>
              <Link
                to={`/docs/${d.id}`}
                className="block rounded-md border border-slate-200 bg-white p-3 text-sm hover:bg-slate-50"
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium">{d.title}</span>
                  <span className="text-xs text-slate-500">{d.product.display_name}</span>
                </div>
                {d.summary ? (
                  <div className="mt-1 text-xs text-slate-600">{d.summary}</div>
                ) : null}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
